import React, { useEffect, useRef } from 'react';
import './CvFrame.css';

const CV_IFRAME_ORIGINS = [
  'https://seanderham1.github.io',
  'http://localhost:3000',
  'http://localhost:3001',
  'http://localhost:3003',
  'http://localhost:3005',
];

const CvFrame = ({ src, title }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return undefined;

    const setIframeHeight = (height) => {
      if (!height || height > 5000) return;

      const nextHeight = `${height + 8}px`;
      iframe.style.height = nextHeight;
      iframe.style.minHeight = nextHeight;
    };

    const handlePostMessage = (event) => {
      if (!event.data || event.data.type !== 'iframeHeight') return;

      const isAllowedOrigin =
        !event.origin ||
        CV_IFRAME_ORIGINS.some((origin) => event.origin.startsWith(origin));

      if (!isAllowedOrigin) return;

      setIframeHeight(event.data.height);
    };

    const handleIframeLoad = () => {
      iframe.contentWindow?.postMessage({ type: 'requestIframeHeight' }, '*');
    };

    window.addEventListener('message', handlePostMessage);
    iframe.addEventListener('load', handleIframeLoad);

    return () => {
      window.removeEventListener('message', handlePostMessage);
      iframe.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return (
    <div className="iframe-container">
      <iframe
        ref={iframeRef}
        src={src}
        width="100%"
        className="cv-iframe"
        title={title}
      />
    </div>
  );
};

export default CvFrame;
